import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      globalSeo: 'settings/seo',
      seoStore: 'store/store',
    }),
  },

  methods: {
    getFullPageTitle(title) {
      const pieces = []
      const hasStoreName = !!this.seoStore && !!this.seoStore.name

      if (hasStoreName && this.globalSeo.include_store_name === 'before') {
        pieces.push(this.seoStore.name)
      }

      pieces.push(title)

      if (hasStoreName && this.globalSeo.include_store_name === 'after') {
        pieces.push(this.seoStore.name)
      }

      return pieces.join(this.globalSeo.title_divider)
    },

    getMetaInfoFromSettings(seo) {
      const metaInfo = {
        title: this.getFullPageTitle(seo.title),
        description: seo.description || '',
        meta: [],
      }

      if (!!seo.og_image) {
        metaInfo.meta.push({ property: 'og:image', content: seo.og_image })
      } else if (!!this.globalSeo.og_image) {
        metaInfo.meta.push({ property: 'og:image', content: this.globalSeo.og_image })
      }

      if (metaInfo.description) {
        metaInfo.meta.push({ name: 'description', content: metaInfo.description })
        metaInfo.meta.push({ property: 'og:description', content: metaInfo.description })
      }

      return metaInfo
    },

    getMetaInfoFrom(seo, defaultTitle = '') {
      const metaInfo = {
        title: this.getFullPageTitle(seo.title || defaultTitle),
        description: seo.description || '',
        meta: [],
      }

      if (seo.hasOwnProperty('meta') && typeof seo.meta !== 'undefined' && seo.meta.length > 0) {
        seo.meta.forEach(tag => {
          let currentTag = {
            [tag.name.attribute]: tag.name.value,
            [tag.value.attribute]: tag.value.value,
          }

          if (tag.hasOwnProperty('additional') && tag.additional.length > 0) {
            tag.additional.forEach(attr => currentTag[attr.attribute] = attr.value)
          }

          metaInfo.meta.push(currentTag)
        })
      }

      return metaInfo
    },
  },
}
